export const ADD_MULTIPLE = 'entities/donationCreditRule/ADD_MULTIPLE';
export const ADD = 'entities/donationCreditRule/ADD';
export const UPDATE = 'entities/donationCreditRule/UPDATE';
export const REMOVE = 'entities/donationCreditRule/REMOVE';
